import UpdateGtinModal from "./UpdateGtinModal";

export default UpdateGtinModal;
